const PERCENT_BASE = 100;

/** Сотые доли процента: поиск отдаёт доли вроде 0.005, и «0.5%» должно пережить перевод. */
const PERCENT_PRECISION = 100;

/**
 * Доля первого платежа в процентах. Поиск отдаёт её дробью от единицы (0.5 — это 50%),
 * поэтому перевод живёт в одном месте: и карточка, и шторка получают уже проценты.
 */
export function toPrepaymentPercent(part: number): number {
  // 0.1 * 100 в двоичной плавающей точке даёт 10.000000000000002 — без округления это утекло бы в подпись.
  return Math.round(part * PERCENT_BASE * PERCENT_PRECISION) / PERCENT_PRECISION;
}
